import { useState } from 'react';
import { testimonials } from '@/mocks/homepage';

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const current = testimonials[activeIndex];

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
          <div className="md:w-3/5">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-2 h-2 rounded-full bg-foreground-950 flex-shrink-0" />
              <span className="text-xs font-medium text-foreground-600 tracking-wider whitespace-nowrap">
                读者口碑
              </span>
            </div>

            <blockquote className="mb-6">
              <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-relaxed">
                &ldquo;{current.quote}&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                {current.name}
              </span>
              <span className="flex items-center gap-1 text-xs text-accent-600 whitespace-nowrap">
                <i className="ri-verified-badge-fill" />
                {current.role}
              </span>
            </div>

            <div className="flex items-center gap-3 mt-8">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIndex(idx)}
                  className={`w-8 h-1 rounded-full transition-all duration-300 cursor-pointer ${
                    idx === activeIndex ? 'bg-foreground-950 w-12' : 'bg-foreground-200'
                  }`}
                  aria-label={`切换到第${idx + 1}条评价`}
                />
              ))}
            </div>
          </div>

          <div className="md:w-2/5">
            <img
              src="https://readdy.ai/api/search-image?query=Young%20Asian%20reader%20portrait%20with%20warm%20soft%20lighting%2C%20black%20and%20white%20editorial%20photography%2C%20clean%20white%20background%2C%20artistic%20portrait%2C%20contemplative%20expression%2C%20modern%20lifestyle%20photography%2C%20minimalist%20composition&width=500&height=600&seq=testimonial-portrait-01&orientation=portrait"
              alt="韩漫在线读者"
              title="韩漫在线读者口碑"
              className="w-full h-72 md:h-96 object-cover object-top rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}